import PropTypes from 'prop-types';
import React from 'react';

import createReactClass from 'create-react-class';

export default createReactClass({
    displayName: 'ExclamationMark',

    PropTypes: {
        width: PropTypes.number,
        height: PropTypes.number,
        className: PropTypes.string
    },

    getDefaultProps() {
        return {
            width: 18,
            height: 18,
            className: ''
        };
    },

    render() {
        let { width, height, className } = this.props;

        return (
            <svg className={className} width={width} height={height} viewBox="0 0 18 18" >
                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <circle fill="#D7233E" cx="9" cy="9" r="9"></circle>
                    <polygon fill="#FFFFFF" points="8 4 8 10 10 10 10 4"></polygon>
                    <polygon fill="#FFFFFF" points="8 12 8 14 10 14 10 12"></polygon>
                </g>
            </svg>
        );
    }
});
